import { ChevronRight as BaseChevronRight } from '@mui/icons-material';
import { styled } from '@mui/joy';

export const ChevronRight = styled(BaseChevronRight)(({ theme: { palette } }) => ({
  verticalAlign: 'middle',
  color: palette.grey4,
  fontSize: '20px',
}));
